import { useSelector } from 'react-redux';

import { selectSelectedAction } from '@/redux/dialogs/selectors';
import { SubAgentAction } from '@/shared/types/action';

import ToolkitAIResponse from './ToolkitAIResponse';
import ToolkitSubAgentAuth from './ToolkitSubAgentAuth';

/**
 * Dispatches the right-hand toolkit panel for a selected `sub_agent` action by
 * its config discriminator (`auth` vs `ai_response`). Keeps `renderActionToolkit`
 * unaware of the sub-agent variants.
 */
const ToolkitSubAgent = () => {
  const selected = useSelector(selectSelectedAction);
  const action = selected?.type === 'sub_agent' ? (selected as SubAgentAction) : null;

  if (action?.sub_agent_config?.type === 'ai_response') {
    return <ToolkitAIResponse />;
  }

  return <ToolkitSubAgentAuth />;
};

export default ToolkitSubAgent;
